(ns com.theplantscape.plant-web.components.plants.link
  (:require [reitit.frontend.easy :as rfe]))

(defn plant-link [plant-id]
  [:a {:href (rfe/href :plant {:plant-id (str plant-id)}) }
   [:i.p-2.text-2xl.fa-brands.fa-pagelines]])

